import React, { useContext } from "react";
import classnames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";

import VarietyHead from "./variety-head";

import { TaskContext } from "contexts/task";
import { findField } from "components/attributes/compare-table/field-builder";
import ReadOnlyField from "components/attributes/compare-table/read-only-field";

const VarietyItem = ({ id, name, linkCode, sharedValues, packAttributes, attributeList, updateVarietyAttribute, varieties }) => {
    const { task } = useContext(TaskContext);

    return (
        <>
            <VarietyHead variety={name} linkCode={linkCode} varieties={varieties} />
            {attributeList.map((attr) => {
                const isLinked = sharedValues.includes(attr.uuid);
                const Field = findField(attr.componentType, isLinked);
                const defaultValue = packAttributes && packAttributes[attr.uuid] ? packAttributes[attr.uuid] : "";

                return (
                    <div key={`VPF_${attr.uuid}_${id}`} className={classnames("variety-item", { "-linked": isLinked })}>
                        <ReadOnlyField
                            key={`VPF_${attr.uuid}_${id}`}
                            Field={Field}
                            attribute={attr}
                            //parentAttribute={varietyAttribute}
                            isCompleted={task.isCompleted}
                            //varietyData={varietyData[variety]}
                            updateVarietyAttribute={updateVarietyAttribute}
                            defaultValue={defaultValue}
                            varietyId={id}
                            readOnly={isLinked}
                        />
                        {isLinked && (
                            <div className="link-state">
                                <FontAwesomeIcon icon={faLink} />
                            </div>
                        )}
                    </div>
                );
            })}
        </>
    );
};

export default VarietyItem;
